import * as Styled from './styled';
import { Props } from './types';

function OutlinedCard({ children, ...props }: Props) {
  return <Styled.OutlinedCard {...props}>{children}</Styled.OutlinedCard>;
}

export default OutlinedCard;
